import React from 'react';
import CountUp from 'react-countup';
import {useInView} from 'react-intersection-observer';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants'
import about from '../assets/about.png';

const About = () => {
    const [ref, inView] = useInView({
        threshold: 0.5,
    })
    return <section className='section min-h-[85vh] lg:min-h-[670px]' id='about' ref={ref}>
        <div className="container mx-auto">
            <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 mb-12'>
                { /* img */}
                <motion.div
                    variants={fadeIn('right', 0.3)}
                    initial="hidden"
                    whileInView={'show'}
                    viewport={{amount: 0.3, once: true}}
                    className='flex-1 h-[640px] hidden lg:flex'>
                    <img src={about} alt='' className='bg-about bg-contain bg-no-repeat bg-top opacity-50'/>
                </motion.div>
                { /* text */}
                <motion.div
                    className='flex-1'
                    variants={fadeIn('left', 0.5)}
                    initial="hidden"
                    whileInView={'show'}
                    viewport={{amount: 0.3, once: true}}>
                    <h2 className='my-4 text-[36px] lg:text-[60px] uppercase leading-[1] text-bg inline-block'>ABOUT US</h2>
                    <p className='mb-6'>
                    We're not your average developers – we're the geniuses who cracked encryption for the FAA (yep, flight data superheroes) and made wallets dance for AAVE, the crypto unicorns.

Imagine serious coding discussions paired with a side of witty jokes. That's how we roll. We're the team that turns debugging into a comedy show, all while crafting top-notch digital experiences.

From FAA security to crypto wallet magic, we've done it all. Our secret? A dash of humor, a pinch of brilliance, and a whole lot of passion.<br/>
                    </p>
                    { /* stats */}
                    <div className='flex gap-x-6 lg:gap-x-10 mb-10'>
                        <div>
                            <div className='text-[40px] font-secondary font-semibold  flex justify-center'>
                                {inView ? <CountUp start={0} end={11} duration={3.8}/> :
                                    null}
                            </div>
                            <div className='text-sm font-semibold tracking-[2px] uppercase'>Years in the business
                            </div>
                        </div>
                        <div>
                            <div className='text-[40px] font-secondary font-semibold  flex justify-center'>
                                {inView ? <CountUp start={0} end={39}   duration={4}/> :
                                    null}<span>+ </span>
                            </div>
                            <div className='font-semibold text-sm tracking-[2px] uppercase'><span className='flex  justify-center'>Projects</span>
                            
                            </div>
                        </div>
                        <div>
                            <div className='text-[40px] font-secondary font-semibold  flex justify-center'>
                                {inView ? <CountUp start={0} end={60} duration={4.5}/> :
                                    null}
                                    <span>+ </span>
                            </div>
                            <div className='font-semibold text-sm tracking-[2px]'><span
                                className='flex justify-center uppercase'>satisfied clients</span>
                            
                            </div>
                        </div>
                    </div>
                   
                </motion.div>
            </div>
        </div>
    </section>;
};

export default About;
